import { legacyPageEntrypoint } from '@atlassian/jira-router-routes-legacy-page-entrypoint/src/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createLegacyEntry } from '@atlassian/jira-route-entry/src/createLegacyEntry.tsx';
import { legacyGinIssueMoveRoute } from '@atlassian/jira-router-routes-legacy-gin-issue-move-routes/src/legacyGinIssueMoveRoute.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyGinIssueMoveRouteEntry = createLegacyEntry(legacyGinIssueMoveRoute, () => ({
	layout: globalLayout,
	entryPoint: () => pageEntryPoint,
}));
